// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sectorId: __t.u64().primaryKey().name("sector_id"),
  worldId: __t.u64().name("world_id"),
  name: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  r: __t.f32(),
  relayR: __t.f32().name("relay_r"),
  warId: __t.u64().name("war_id"),
  sideA: __t.string().name("side_a"),
  sideB: __t.string().name("side_b"),
  active: __t.bool(),
  capA: __t.f32().name("cap_a"),
  capB: __t.f32().name("cap_b"),
  capAt: __t.timestamp().name("cap_at"),
  vacantSince: __t.timestamp().name("vacant_since"),
  scoreA: __t.u32().name("score_a"),
  scoreB: __t.u32().name("score_b"),
  openedAt: __t.timestamp().name("opened_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
